export const _tabColor = "#428e92";
export const _sidebarColorLight = "#484848";
export const _sidebarColorDark = "#222222";
export const _appBarColorLight = "#484848";
export const _appBarColorDark = "#111111";
export const _backgroundColorLight = "#fafafa";
export const _backgroundColorDark = "#333333";
export const primaryColor = "#1976d2";
export const secondaryColor = "#dc004d";
export const secondaryColorWithOpacity = "#dc000020";

export const getDesignTokens = (mode) => ({
    palette: {
        mode,
        ...(mode === "light"
            ? {
                  primary: {
                      main: primaryColor,
                      contrastText: "#fff",
                  },
                  secondary: {
                      main: secondaryColor,
                      contrastText: "#fff",
                  },
                  background: {
                      default: _backgroundColorLight,
                  },
              }
            : {
                  primary: {
                      main: primaryColor,
                      contrastText: "#fff",
                  },
                  secondary: {
                      main: secondaryColor,
                      contrastText: "#fff",
                  },
                  background: {
                      default: _backgroundColorDark,
                  },
              }),
    },
    components: getThemedComponents(mode),
    // typography,
    shape: {
        borderRadius: 5,
    },
});

export const getThemedComponents = (_mode) => ({
    MuiCssBaseline: {
        "@global": {
            body: {
                overflow: "auto",
            },
            "*::-webkit-scrollbar-track": {
                backgroundColor: "transparent",
            },

            "*::-webkit-scrollbar": {
                height: "8px",
                width: "8px",
            },
            "*::-webkit-scrollbar-thumb": {
                backgroundColor: "#9fa6ab63",
                borderRadius: 5,
            },
            "* img": {
                maxWidth: "100%",
            },
        },
    },

    MuiAppBar: {
        styleOverrides: {
            colorInherit: {
                backgroundColor: _mode === "light" ? _appBarColorLight : _appBarColorDark,
                color: "#fff",
            },
        },
        defaultProps: {
            color: "inherit",
        },
    },

    MuiTable: {
        styleOverrides: {
            border: "3px solid",
            borderRadius: 15,
            color: _tabColor,
        },
    },

    MuiTableCell: {
        styleOverrides: {
            head: {
                backgroundColor: _tabColor,
                color: "#fff",
            },
        },
    },

    MuiTabs: {
        styleOverrides: {
            indicator: {
                backgroundColor: _tabColor,
                borderRadius: "50px",
                height: 3,
            },
        },
    },

    MuiTab: {
        styleOverrides: {
            root: {
                "&.MuiTab-root": {
                    textTransform: "capitalize",
                    borderRadius: "12px 12px 4px 4px",
                    margin: 7,
                },
                "&.Mui-selected": {
                    backgroundColor: _tabColor,
                    color: "#fff",
                },
            },
        },
    },

    MuiTooltip: {
        defaultProps: {
            arrow: true,
        },
    },

    MuiPaper: {
        styleOverrides: {
            root: {
                backgroundColor: _mode === "light" ? _backgroundColorLight : _backgroundColorDark,
            },
        },
    },

    MuiDrawer: {
        styleOverrides: {
            paper: {
                backgroundColor: _mode === "light" ? _backgroundColorLight : _backgroundColorDark,
            },
        },
    },

    MuiDataGrid: {
        styleOverrides: {
            columnHeader: {
                backgroundColor: _tabColor,
                color: "#fff",
            },
        },
    },

    MuiFormHelperText: {
        styleOverrides: {
            root: {
                fontSize: "11px",
                color: "#d32f2f"
            },
        },
    },
});
